import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import {
	MemberAvatarsItem,
	MemberAvatarsRestList,
} from 'packages/kakapo-ui-kit/components/member-avatars/MemberAvatars';

const LearningEventAttendeeAvatars = (props: { event: graphql.LearningEvent }) => {
	const { t } = useTranslation();

	const edges = _.sortBy(
		props.event.attendees.edges,
		({ node }) => `${node.firstName} ${node.lastName}`,
	);

	const rest = edges.slice(3).map(({ node }) => node);

	return (
		<Flex>
			{edges.slice(0, 3).map(({ node }) => (
				<MemberAvatarsItem user={node} overlap />
			))}
			{rest.length > 0 && (
				<MemberAvatarsRestList
					title={t('learningEventAttendeesModal.title')}
					allUsers={edges.map(({ node }) => node as graphql.User)}
					numberOfExtraUsers={rest.length}
					restUsers={rest}
					overlap
				/>
			)}
		</Flex>
	);
};

export default LearningEventAttendeeAvatars;
